import { connectAndForwardRef } from 'util/redux'
import { selectGroupsById } from 'selectors/app/groups'
import { selectAgentsByIdOrChatId } from 'ducks/chat/selectors/users'
import StateEventView from './view'

const select = state => ({
  agentsByChatId: selectAgentsByIdOrChatId(state),
  teamsById: selectGroupsById(state),
})

export default connectAndForwardRef(select)(StateEventView)
